export default {
  ID: 'wix-vod-payment',
  TYPES: {
    SALE: 'sale',
    RENT: 'rent',
    SUBSCRIPTION: 'subscription',
    SUBSCRIPTION_CANCEL: 'subscription-cancel',
  },
};



// WEBPACK FOOTER //
// ./src/shared/constants/payment-message-proxy.js